import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import GuildService from '../../../services/guild.service';
import { getNotification } from '../Notifications/slice';
export const initialState = {
    requests: null,
    pending: false,
    isDataSent: false
};
export const getRequests = createAsyncThunk('guilds/:id/requests', async (guildId) => {
    try {
        return await GuildService.getRequests(guildId);
    }
    catch (err) {
        return err.response;
    }
});
export const acceptRequest = createAsyncThunk('guilds/:id/accept/:requestId', async (data, { dispatch }) => {
    try {
        await GuildService.acceptRequest(data);
        if (data.notificationId) {
            dispatch(getNotification(data.notificationId));
        }
        return await GuildService.getRequests(data.guildId);
    }
    catch (err) {
        return err.response;
    }
});
export const declineRequest = createAsyncThunk('guilds/:id/decline/:userId', async (data, { dispatch }) => {
    try {
        await GuildService.declineRequest(data);
        if (data.notificationId) {
            dispatch(getNotification(data.notificationId));
        }
        return await GuildService.getRequests(data.guildId);
    }
    catch (err) {
        return err.response;
    }
});
export const race = createSlice({
    name: 'race',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getRequests.fulfilled, (state, action) => {
            if (action.payload.status === 200) {
                state.requests = action.payload.data;
            }
            else {
                state.requests = null;
            }
        });
        builder.addCase(getRequests.rejected, (state) => {
            state.isDataSent = false;
        });
        builder.addCase(acceptRequest.fulfilled, (state, action) => {
            if (action.payload.status === 200) {
                state.requests = action.payload.data;
                state.isDataSent = true;
                state.pending = true;
            }
            else {
                state.requests = null;
            }
        });
        builder.addCase(acceptRequest.rejected, (state) => {
            state.pending = false;
            state.isDataSent = false;
        });
        builder.addCase(acceptRequest.pending, (state) => {
            state.pending = true;
        });
        builder.addCase(declineRequest.fulfilled, (state, action) => {
            if (action.payload.status === 200) {
                state.requests = action.payload.data;
                state.isDataSent = true;
                state.pending = true;
            }
            else {
                state.requests = null;
            }
        });
        builder.addCase(declineRequest.rejected, (state) => {
            state.pending = false;
            state.isDataSent = false;
        });
        builder.addCase(declineRequest.pending, (state) => {
            state.pending = true;
        });
    }
});
export default race.reducer;
